const TRANSLATION_KEY_PATTERN = /^[A-Z][A-Z0-9_]*$/;

/**
 * Fallback text for the `translate` pipe when a backend error message may be
 * plain text instead of a translation key. Returns `undefined` for translation
 * keys, so a genuinely missing key is still hidden.
 *
 * @param expression Message expression received from the backend.
 */
export function rawMessageFallback(expression?: string): string | undefined {
  return expression && !TRANSLATION_KEY_PATTERN.test(expression)
    ? expression
    : undefined;
}
